/*
 * Copyright (C) 2026 to Present Applause App Quality, Inc. All rights reserved.
 */

import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

// A forum category as a link to its page, "Parent: Name" when the category has a parent.
@Component({
  selector: 'ut-category-link',
  templateUrl: './category-link.component.html',
  styleUrls: ['./category-link.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class UtCategoryLinkComponent {
  @Input({ required: true }) category: { id: number; name: string; parent?: { name: string } | null };

  // A text link in the surrounding style, for places like a breadcrumb where a chip would stand out.
  @Input() plain = false;
}
